<div id="tp-asset-card-container" class="prevent-select" [style.border-color]="pillAndBorderColor">
    <div class="tp-ac-row one">
        <div>
            <img [src]="(imagePath + mowerImage)" alt="">
        </div>
        <div id="tp-ar-text">
            <div id="img-name-container" class="row-datum">
                <div>{{ asset?.name }}</div>
            </div>
            <div id="online-status-sn" class="row-datum">
                <img [src]="onlineStatusImgUri" alt="">
                <div>{{ asset?.serialNumber }}</div>
            </div>
        </div>
    </div>
    <div class="tp-ac-row two">
        <div id="tp-ac-score" class="row-datum">
            <div> {{ Math.round(asset?.lastScore) ?? '--' }}/{{ asset?.maxScore ?? '--'  }}</div>
        </div>
        <div id="tp-ac-status" class="row-datum">
            <div id="tp-ac-pill" [style.background-color]="pillAndBorderColor">{{ pillText | translate }}</div>
        </div>
    </div>

</div>
